module.exports = __webpack_public_path__ + "img/2.c53ef888.png";